// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-inline li[data-v-2315b9be] {\n    margin-right: 30px;\n}\n\n", ""]);
// Exports
module.exports = exports;
